<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Dialog } from '@progress/kendo-vue-dialogs'
import { Button as KButton } from '@progress/kendo-vue-buttons'
import { GetLoginUrl, GetCheckoutUrl } from '../stores/SettingsStore'

const { t } = useI18n()

const props = defineProps<{
  visible: boolean
}>()

const emit = defineEmits(['close'])

async function handleLoginClick() {
  const returnUrl = await GetCheckoutUrl()
    window.location.href =
      (await GetLoginUrl()) + '?returnUrl=' + encodeURIComponent(returnUrl)
}

async function handleCheckoutClick() {
  const checkoutUrl = await GetCheckoutUrl()
  window.location.href = checkoutUrl
}

function handleClose() {
  emit('close')
}
</script>

<template>
  <Dialog
    :title="t('account.ChooseOption')"
    :visible="visible"
    @close="handleClose"
    class="account-choice-popup"
  >
    <div class="choice-content">
      <p class="choice-description">{{ t('account.ChooseDescription') }}</p>

      <div class="choice-buttons">
        <KButton
          @click="handleLoginClick"
          :theme-color="'primary'"
          class="choice-button login-button"
        >
          {{ t('account.HaveAccount') }}
        </KButton>

        <KButton
          @click="handleCheckoutClick"
          :theme-color="'primary'"
          class="choice-button checkout-button"
        >
          {{ t('account.CreateAtCheckout') }}
        </KButton>
      </div>
    </div>
  </Dialog>
</template>

<style lang="scss">
.account-choice-popup {
  max-width: 500px;
  margin: 0 auto;
  left:33%;
}

.choice-content {
  padding: 1rem;
  text-align: center;
}

.choice-description {
  @include typography-body-large;
  margin-bottom: 2rem;
  color: #333;
}

.choice-buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.choice-button {
  @include typography-body-large;
  width: 80%;
  padding: 1rem;
  background-color: #2b6b77;
  border: unset;
}
.login-button:hover {
  background-color: #1e4b54;
}
.checkout-button {
    background-color: unset;
    color: #2b6b77;
    text-decoration: underline;
    border: unset;
}
.checkout-button:hover {
    background-color: unset;

}


</style>
